import Component from "../../../../js/assets/component.js"
import Util from '../../../../js/assets/util.js'

class Participants extends Component{
  constructor(selector) {
    // set root element
    super(selector)
  }

  static getAge(birthDate, departureDate) {
    let diffMs = departureDate - birthDate
    let ageDiff = new Date(diffMs)
    return ageDiff.getFullYear() - 1970
  }

  static getExpectedAgeCategoryId(age) {
    if (age >= 12) {
      return 1
    } else if (age >= 2) {
      return 2
    } else {
      return 3
    }
  }

  static checkNumSingle(n) {
    return (n * (n + 1)) / 2
  }

  static checkNumTwin(n) {
    return n * (n + 1);
  }

  onClickAgeCategory() {
    if(window.confirm('年齢区分を変更する場合は前のページに戻る必要があります。変更しますか?')) {
      window.location.href = this.$el.data('detailPageUrl')
    }
  }

  // 部屋割りの正当性チェック
  validateRoomAllocation() {
    // 部屋数
    const single_room_number = this.$el.data('singleRoomNumber')
    const twin_room_number = this.$el.data('twinRoomNumber')

    // 部屋番号を足し込む 部屋1-"1" + 部屋1-"2" = 3
    let sum_single_input = 0;
    // 部屋番号を足し込む 部屋2-"1" + 部屋2-"2" + 部屋2-"3" = 6
    let sum_twin_input = 0;

    // 幼児は部屋割りの整合性チェック時に、ひとりとしてカウントしない
    const INFANT = 3;
    let formsExceptInfants =  this.$el.find(".participantForm").filter(function(index, elm) {
      let categoryId = $(elm).find("input[name*='age_category']").val()

      if (!categoryId) {
        return false
      }

      return Number(categoryId) !== INFANT
    })

    const SINGLE = '1';
    // const TWIN = '2';
    formsExceptInfants.find('.room_info').each(function() {
      let room_type, room_no;
      [room_type, room_no] = $(this).val().split('-');
      if (room_type === SINGLE) {
        sum_single_input += Number(room_no);
      } else {
        sum_twin_input += Number(room_no);
      }
    });

    if (single_room_number > 0) {
      const check_num_single = this.constructor.checkNumSingle(single_room_number);
      if (check_num_single !== sum_single_input) {
        Util.alert('部屋割りを正しく選択してください。');
        return false;
      }
    }

    if (twin_room_number > 0) {
      const check_num_twin = this.constructor.checkNumTwin(twin_room_number);
      if (check_num_twin !== sum_twin_input) {
        Util.alert('部屋割りを正しく選択してください。');
        return false;
      }
    }

    return true
  }

  // 年齢区分と生年月日の整合性を見る
  validateAgeCategory() {
    const participantNumber = this.$el.data('participantNumber')
    const departureDate = new Date(this.$el.data('departureDate'))

    for (let i = 0; i < participantNumber; i++) {
      let yearSelectBox = this.$el.find(`#shopping_order_Participants_${i}_birth_year`)[0]
      yearSelectBox.setCustomValidity("")

      // 空欄のときはスルー
      let birthDate = this.getBirthDate(i)
      if (birthDate === null) {
        return
      }

      let age = this.constructor.getAge(birthDate, departureDate)
      let expectedAgeCategoryId = this.constructor.getExpectedAgeCategoryId(age)

      let actualAgeCategoryId = parseInt(this.$el.find(`#shopping_order_Participants_${i}_age_category_hidden`).val())

      if (expectedAgeCategoryId !== actualAgeCategoryId) {
        yearSelectBox.setCustomValidity("生年月日と、年齢区分が合っていません。")
      }
    }
  }

  getBirthDate(nth) {
    let year = this.$el.find(`#shopping_order_Participants_${nth}_birth_year`).val()
    let month = this.$el.find(`#shopping_order_Participants_${nth}_birth_month`).val()
    let day = this.$el.find(`#shopping_order_Participants_${nth}_birth_day`).val()
    if (!year || !month || !day) {
      // 入力されていない
      return null
    }

    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
  }

  setSaleType () {
    const saleType = this.$el.find('input[name="_shopping_order[Payment]"]:checked').val()
    this.$el.find('input:hidden[name="SaleType"]').val(saleType);
  }

  preventDoubleClick() {
    this.el.querySelector('#shopping-submit-button').setAttribute('disabled', 'disabled')
  }

  mounted() {

    // 年齢区分クリック時
    this.$el.find(".participantForm_ageCategoryValue").click(() => {
      this.onClickAgeCategory()
    })

    // 申し込みボタンクリック時
    this.el.querySelector('#shopping-confirm').addEventListener('click', (event) => {

      // 部屋割り整合性をチェック
      if (!this.validateRoomAllocation()) {
        event.preventDefault()
        return
      }

      // 年齢区分の整合性をチェック
      this.validateAgeCategory()

      this.setSaleType()
    })

    // 申し込みサブミット時(バリデーション後)
    this.el.querySelector('#shopping_confirm').addEventListener('submit', () => {
      this.preventDoubleClick()
    })
  }
}

// export as singleton
let instance = new Participants("#participants")

// Object.seal(instance)
export default instance
